import { IListItem } from "@nkr/models/list-item";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";
import { IMicrositeLookupDataResponse } from "..";

interface IRetVal {
    loading: boolean,
    error: string,
    eventTypes: IListItem[]
}

const useMicrositeLookupData = (): IRetVal => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [eventTypes, setEventTypes] = useState<IListItem[]>([]);

    const { dispatch } = useAppHookContext();

    const reset = () => {
        setEventTypes([]);
    }

    useEffect(() => {
        setLoading(true);
        setError('');

        const fetchData = async () => {
            let config: IGet = {
                url: `${__API__}/microsite/lookup-data`
            };

            try {
                const response: IMicrositeLookupDataResponse = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    setEventTypes(response.data.results.eventTypeList);
                } else {
                    setError('Unable to load microsite lookup data');
                    reset();
                }

            } catch (err) {
                reset()
                setError(err)
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    return { loading, error, eventTypes }
}

export default useMicrositeLookupData